import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=4deb4b6a&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4deb4b6a')) {
      api.createRecord('4deb4b6a', component.options)
    } else {
      api.reload('4deb4b6a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=4deb4b6a&", function () {
      api.rerender('4deb4b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/configs/edit.vue"
export default component.exports